import {
  makeFreeDeliveryThreshold,
  makeIsReachThreshold,
  makeSuggestCoupon,
} from '../../../redux/selectors/freeDeliverySelector';
import { useSelector } from '../../../redux/utils';

export const useData = () => {
  const freeShippingDiff: number | undefined = useSelector(
    makeFreeDeliveryThreshold()
  );
  const isReachThreshold = useSelector(makeIsReachThreshold());
  const suggestCoupon = useSelector(makeSuggestCoupon());

  return {
    freeShippingDiff,
    isReachThreshold,
    suggestCoupon,
  };
};
